export function getDisplayName(
  user: { name?: string; first_name?: string; last_name?: string } | undefined,
  userFallback: string
): string {
  if (!user) return '';
  if (user.name) return user.name;
  const first = user.first_name ?? '';
  const last = user.last_name ?? '';
  return [first, last].filter(Boolean).join(' ') || userFallback;
}

export function getInitials(displayName: string): string {
  const parts = displayName.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return displayName.slice(0, 2).toUpperCase() || 'U';
}

export function getInitialsColor(initials: string) {
  const colors = [
    { bg: '#EDE9FE', text: '#7C3AED' },
    { bg: '#DBEAFE', text: '#2563EB' },
    { bg: '#D1FAE5', text: '#059669' },
    { bg: '#FEF3C7', text: '#D97706' },
    { bg: '#FCE7F3', text: '#DB2777' },
    { bg: '#E0E7FF', text: '#4F46E5' },
  ];
  const index = initials.charCodeAt(0) % colors.length;
  return colors[index];
}
